/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsUserLicenseSummary
 */
export interface MelcoModelsUserLicenseSummary {
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsUserLicenseSummary
     */
    total_licenses?: number;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsUserLicenseSummary
     */
    assigned_licenses?: number;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsUserLicenseSummary
     */
    available_licenses?: number;
}

export function MelcoModelsUserLicenseSummaryFromJSON(json: any): MelcoModelsUserLicenseSummary {
    return MelcoModelsUserLicenseSummaryFromJSONTyped(json, false);
}

export function MelcoModelsUserLicenseSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUserLicenseSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_licenses': !exists(json, 'total_licenses') ? undefined : json['total_licenses'],
        'assigned_licenses': !exists(json, 'assigned_licenses') ? undefined : json['assigned_licenses'],
        'available_licenses': !exists(json, 'available_licenses') ? undefined : json['available_licenses'],
    };
}

export function MelcoModelsUserLicenseSummaryToJSON(value?: MelcoModelsUserLicenseSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_licenses': value.total_licenses,
        'assigned_licenses': value.assigned_licenses,
        'available_licenses': value.available_licenses,
    };
}


